<template>
  <v-row justify="center" align="center">
    <v-col cols="12" sm="6" md="4" >
      <div id="create" v-if="listingData">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col>There is something wrong happened</v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-col>
  </v-row>
</template>

<script>


export default {
  name: "PaymentCanceled",

  data: () => ({
    message: "",
    snackbar: false,
    length: 4,
    tab: null,
  }),
  created() {},
  mounted() {
  },
  computed: {
    
  },
  watch: {},
  methods: {
  },
  beforeDestroy() {},
};
</script>
